import React, { useEffect, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { months } from "../../../../../../Utils/months";
import { getNextMonth } from "../../../Utils/Utils";
import { CurrencyDisplay, CurrencyInput, KgDisplay, KgInput } from "../../../Utils/Inputs";

export default function SolidosTotalesRows(props) {
    const { monthIndex, isFirstTable, month, prodMesKgSecos, prodMesValorTotal } = props;

    const { setValue, control } = useFormContext();

    const BaseSolidosDataCostoVentas = 'ComparativoCostoVentas.SolidosData';

    // Produccion del mes
    const prodMesCostoKgSec = useMemo(() => prodMesValorTotal / prodMesKgSecos, [prodMesValorTotal, prodMesKgSecos]);

    // (+) Prod. Term. Mes anterior
    const prodTermMesAnteriorKgSecos = useWatch({
        control,
        name: `${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${month}.KgSecos`,
    });
    const prodTermMesAnteriorCostoKgSec = useWatch({
        control,
        name: `${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${month}.CostoKgSec`,
    });
    const prodTermMesAnteriorValorTotal = useMemo(() => prodTermMesAnteriorKgSecos * prodTermMesAnteriorCostoKgSec, [prodTermMesAnteriorKgSecos, prodTermMesAnteriorCostoKgSec]);

    // (=) Prod. Term. Disponible
    const prodTermDisponibleKgSecos = useMemo(() => prodMesKgSecos + prodTermMesAnteriorKgSecos, [prodMesKgSecos, prodTermMesAnteriorKgSecos]);
    const prodTermDisponibleValorTotal = useMemo(() => prodMesValorTotal + prodTermMesAnteriorValorTotal, [prodMesValorTotal, prodTermMesAnteriorValorTotal]);
    const prodTermDisponibleCostoKgSec = useMemo(() => prodTermDisponibleValorTotal / prodTermDisponibleKgSecos, [prodTermDisponibleValorTotal, prodTermDisponibleKgSecos]);

    // (-) Costo Vta. Del Mes
    const costoVtaMesKgSecos = useWatch({
        control,
        name: `${BaseSolidosDataCostoVentas}.CostoVtaDelMes.${month}.KgSecos`,
    });
    const costoVtaMesCostoKgSec = prodTermDisponibleCostoKgSec;
    const costoVtaMesValorTotal = useMemo(() => costoVtaMesKgSecos * costoVtaMesCostoKgSec, [costoVtaMesKgSecos, costoVtaMesCostoKgSec]);

    // (=) Prod. Termin. Final
    const prodTerminFinalKgSecos = useMemo(() => prodTermDisponibleKgSecos - costoVtaMesKgSecos, [prodTermDisponibleKgSecos, costoVtaMesKgSecos]);
    const prodTerminFinalCostoKgSec = prodTermDisponibleCostoKgSec;
    const prodTerminFinalValorTotal = useMemo(() => prodTerminFinalKgSecos * prodTerminFinalCostoKgSec, [prodTerminFinalKgSecos, prodTerminFinalCostoKgSec]);

    // Actualizar valores de Prod. Term. Mes anterior
    useEffect(() => {
        const nextMonth = getNextMonth(monthIndex);
        if (nextMonth === 'enero') return;

        setValue(`${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${nextMonth}.KgSecos`, prodTerminFinalKgSecos);
        setValue(`${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${nextMonth}.CostoKgSec`, prodTerminFinalCostoKgSec);
    }, [
        prodTerminFinalKgSecos, prodTerminFinalCostoKgSec, prodTerminFinalValorTotal,
        month, setValue
    ]);

    // Para guardar Costo Vta Del Mes en CostoKgSec
    useEffect(() => {
        setValue(`${BaseSolidosDataCostoVentas}.CostoVtaDelMes.${month}.CostoKgSec`, costoVtaMesCostoKgSec);
    }, [costoVtaMesCostoKgSec, month, setValue]);

    // Para guardar Prod. Termin. Final
    useEffect(() => {
        setValue(`${BaseSolidosDataCostoVentas}.ProdTerminFinal.${month}.KgSecos`, prodTerminFinalKgSecos);
        setValue(`${BaseSolidosDataCostoVentas}.ProdTerminFinal.${month}.CostoKgSec`, prodTerminFinalCostoKgSec);
    }, [prodTerminFinalKgSecos, prodTerminFinalCostoKgSec, month, setValue]);

    // CASOS ESPECIALES
    // Prod. Term. Mes anterior para enero y meses posteriores
    let prodTermMesAnteriorRow = null;
    if (!isFirstTable) {
        prodTermMesAnteriorRow = (
            <tr>
                <td><KgDisplay value={prodTermMesAnteriorKgSecos} /></td>
                <td><CurrencyDisplay value={prodTermMesAnteriorCostoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={prodTermMesAnteriorValorTotal} /></td>
            </tr>
        );
    } else {
        prodTermMesAnteriorRow = (
            <tr>
                <td>
                    <KgInput
                        name={`${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${month}.KgSecos`} />
                </td>
                <td>
                    <CurrencyInput
                        name={`${BaseSolidosDataCostoVentas}.ProdTermMesAnterior.${month}.CostoKgSec`}
                        decimalScale={5} />
                </td>
                <td><CurrencyDisplay value={prodTermMesAnteriorValorTotal} /></td>
            </tr>
        );
    }


    return (
        <React.Fragment>
            {/* (=) Producción del mes */}
            <tr className="celda-totales">
                <td><KgDisplay value={prodMesKgSecos} /></td>
                <td><CurrencyDisplay value={prodMesCostoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={prodMesValorTotal} /></td>
            </tr>
            {/* (+) Prod. Term. Mes anterior */}
            {prodTermMesAnteriorRow}
            {/* (=) Prod. Term. Disponible */}
            <tr className="celda-totales">
                <td><KgDisplay value={prodTermDisponibleKgSecos} /></td>
                <td><CurrencyDisplay value={prodTermDisponibleCostoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={prodTermDisponibleValorTotal} /></td>
            </tr>
            {/* (-) Costo Vta. Del Mes  */}
            <tr>
                <td>
                    <KgInput
                        name={`${BaseSolidosDataCostoVentas}.CostoVtaDelMes.${month}.KgSecos`} />
                </td>
                <td><CurrencyDisplay value={costoVtaMesCostoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={costoVtaMesValorTotal} /></td>
            </tr>
            {/* (=) Prod. Termin. Final  */}
            <tr className="celda-totales">
                <td><KgDisplay value={prodTerminFinalKgSecos} /></td>
                <td><CurrencyDisplay value={prodTerminFinalCostoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={prodTerminFinalValorTotal} /></td>
            </tr>
        </React.Fragment>
    );
}
